import React, { useState, useMemo, useEffect } from 'react';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import { Config } from '@/config';
import { useNavigate } from 'react-router-dom';
import { UserApi } from '@/sdk/UserApi';

const useTokenUpdate = () => {
  const userApi = new UserApi({ baseURL: Config.API_URL });
  const navigate = useNavigate();

  const tokenUpdate = async () => {
    try {
      const { data } = await userApi.userControllerReissue({
        headers: {
          Authorization: `Bearer ${String(sessionStorage.getItem('refreshToken'))}`,
          'Content-Type': 'application/json',
        },
      });
      sessionStorage.setItem('accessToken', data.accessToken);
      sessionStorage.setItem('refreshToken', data.refreshToken);
    } catch (err: any) {
      sessionStorage.clear();
      navigate('/login');
    }
  };

  useEffect(() => {
    const checkAndUpdateToken = () => {
      tokenUpdate();
    };

    const interval = setInterval(checkAndUpdateToken, 1000 * 60 * 10);
    return () => clearInterval(interval);
  }, []);

  return null;
};

export default useTokenUpdate;
